import { MDXProvider } from '@mdx-js/react';
import { useLocation } from 'react-router';
import { SmartTextLink } from 'scoobie';

import { content } from '../content/index.ts';
import { makeMdxParagraph } from '#src/components/mdx/mdxComponents.tsx';
import { useDatadog } from '#src/components/Datadog/Datadog.tsx';

const LocationAwareSmartTextLink = (
  props: React.JSX.IntrinsicElements['a'],
) => {
  const { pathname } = useLocation();

  const href = props.href;

  if (href === pathname) {
    return props.children;
  }

  if (typeof href === 'undefined') {
    throw new Error('SmartTextLink requires an href');
  }

  return (
    <SmartTextLink {...props} href={href}>
      {props.children}
    </SmartTextLink>
  );
};

const DeprecatedParagraph = makeMdxParagraph({
  tone: 'critical',
});

export const SchemaMarkdown = ({
  type,
  warning,
}: {
  type: string;
  warning?: boolean;
}) => {
  const datadog = useDatadog();
  const nameWithFirstUpper = type.charAt(0).toUpperCase() + type.slice(1);

  const Component =
    content[type as keyof typeof content] ||
    content[nameWithFirstUpper as keyof typeof content];

  if (!Component) {
    datadog.addError(`No content for ${type}`);
    return null;
  }

  return (
    <MDXProvider
      components={{
        a: LocationAwareSmartTextLink,
        ...(warning ? { p: DeprecatedParagraph } : {}),
      }}
    >
      <Component />
    </MDXProvider>
  );
};
